export function setQueryParam(key: string, value: number | string) {
  return window.history.replaceState(null, "", `?${key}=${value}`);
}
export function setQueryParams(params: { key: string, value: string | number }[]) {
  let query = ''
  for (const param of params) {
    if (query != "") {
      query += `&${param.key}=${param.value}`
    } else {
      query += `?${param.key}=${param.value}`
    }
  }
  return window.history.replaceState(null, "", query);

}
export function getQueryParam(key: string) {
  // @ts-ignore
  const params = new Proxy(new URLSearchParams(window.location.search), {
    // @ts-ignore
    get: (searchParams, prop) => searchParams.get(prop),
  });
  // @ts-ignore
  return params[key] || null;
}
